import moment from 'moment';
import 'moment/locale/fr';

export const AUTH_TOKEN = 'auth-token';
export const ROLES = 'roles';
export const PERMISSIONS = 'permissions';
export const USER = 'user';

export const languages = [
  { code: 'fr', label: 'Français' },
  { code: 'en', label: 'English' },
];

moment.locale('fr');
export const m = moment;



// WEBPACK FOOTER //
// ./src/constants.js